<form [formGroup]="registroActividadAcreditacionFormGroup">
  <h4>Indicar las etapas a acreditar</h4>

  <rpe-check-list-tooltips-form [formInput]="formInputCheckTooltipsList" (formValueChanges)="formValueChanges($event)"
    (formStatusChanges)="formStatusChanges($event)"></rpe-check-list-tooltips-form>

  <div class="row" *ngFor="let elemento of listado; index as i" [ngClass]="routeAnimationsElements">
    <h5>Indicar las especies para la etapa {{elemento.nombre}}</h5>
    <ng-select [formControlName]="especiesArray[elemento.id - 1]" placeholder="Especie: *" [multiple]="true">
      <ng-option *ngFor="let ge of obtenerEspecies(elemento.id)" [value]="ge.id">
        {{ ge.nombre }}
      </ng-option>
    </ng-select>
  </div>
</form>
<div class="row buttons d-flex justify-content-between pad" [ngClass]="routeAnimationsElements">
  <button (click)="onCancel()" mat-raised-button>
    {{ 'rpe.vista-usuario.volver' | translate }}
  </button>
  <button type="submit" mat-raised-button (click)="onGuardar()" color="primary">
    {{ 'rpe.vista-usuario.guardar-y-continuar' | translate }}
  </button>
</div>